module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAKlBMVEUAAABZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGpZYGp6spkjAAAADXRSTlMA1xa9Hg7H3czBMRoQRJJmrgAAADJJREFUCNdjYGBQXsDAwCRrwMCw8cYBBhbZVAYG92sBDAxzLzEAWTeBLJAYWBasDqwDAEkYDA+gzc34AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_prev_hover.png
// module id = VH8R
// module chunks = 9